export default __webpack_public_path__ + "static/media/Map-3.6202ba63.jpeg";